import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-6" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-heading font-semibold text-primary-800" }, " Tell us about yourself "),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-primary-500 text-sm" }, " We just need some basic details to set up your account. Your data won't be shared with third parties. ")
], -1)
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, [
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "first_name",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, [
  /*#__PURE__*/_createTextVNode(" First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "last_name",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, [
  /*#__PURE__*/_createTextVNode(" Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "pt-2" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "inline-flex items-center justify-center w-full px-6 py-3 text-white bg-accent-600 rounded-lg hover:bg-accent-700 transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2 sm:w-auto"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Continue"),
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "w-5 h-5 ml-2",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M14 5l7 7m0 0l-7 7m7-7H3"
      })
    ])
  ])
], -1)

import { reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  emits: ["details_set"],
  setup(__props, { emit }) {



const user = reactive({
  email: "",
  first_name: "",
  last_name: "",
  image: "",
});

const errors = reactive({
  email: false,
  first_name: false,
  last_name: false,
});

const resetErrors = () => {
  errors.email = false;
  errors.first_name = false;
  errors.last_name = false;
};

const done = () => {
  if (user.email !== "" && user.first_name !== "" && user.last_name !== "") {
    emit("details_set", user);
  } else {
    Object.entries(user).forEach(([key, value]) => {
      if (value === "" && key in errors) {
        errors[key as keyof typeof errors] = true;
      }
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("form", {
      class: "space-y-5",
      onSubmit: _withModifiers(done, ["prevent"])
    }, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          id: "email",
          type: "email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(user).email) = $event)),
          onChange: resetErrors,
          placeholder: "you@example.com",
          class: _normalizeClass(["w-full px-4 py-3 text-primary-800 border rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors", _unref(errors).email ? 'border-red-500' : 'border-primary-200'])
        }, null, 34), [
          [_vModelText, _unref(user).email]
        ]),
        (_unref(errors).email)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Please enter your email "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            id: "first_name",
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(user).first_name) = $event)),
            onChange: resetErrors,
            placeholder: "John",
            class: _normalizeClass(["w-full px-4 py-3 text-primary-800 border rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors", _unref(errors).first_name ? 'border-red-500' : 'border-primary-200'])
          }, null, 34), [
            [_vModelText, _unref(user).first_name]
          ]),
          (_unref(errors).first_name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Please enter your first name "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            id: "last_name",
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(user).last_name) = $event)),
            onChange: resetErrors,
            placeholder: "Smith",
            class: _normalizeClass(["w-full px-4 py-3 text-primary-800 border rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors", _unref(errors).last_name ? 'border-red-500' : 'border-primary-200'])
          }, null, 34), [
            [_vModelText, _unref(user).last_name]
          ]),
          (_unref(errors).last_name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Please enter your last name "))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_10
    ], 40, _hoisted_2)
  ]))
}
}

})